var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaseManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.74 11.39L21.3 18.59C21.1637 19.2695 20.7964 19.8808 20.2605 20.3201C19.7245 20.7594 19.053 20.9997 18.36 21H4C3.20435 21 2.44129 20.6839 1.87868 20.1213C1.31607 19.5587 1 18.7956 1 18V6C1 5.20435 1.31607 4.44129 1.87868 3.87868C2.44129 3.31607 3.20435 3 4 3H8C8.19603 3.00153 8.38729 3.06065 8.55 3.17L11.3 5H17C17.7957 5 18.5587 5.31607 19.1213 5.87868C19.6839 6.44129 20 7.20435 20 8H18C18 7.73478 17.8946 7.48043 17.7071 7.29289C17.5196 7.10536 17.2652 7 17 7H11C10.804 6.99847 10.6127 6.93935 10.45 6.83L7.7 5H4C3.73478 5 3.48043 5.10536 3.29289 5.29289C3.10536 5.48043 3 5.73478 3 6V18C3 18.2652 3.10536 18.5196 3.29289 18.7071C3.48043 18.8946 3.73478 19 4 19H4.18L5.7 11.41C5.83629 10.7305 6.20361 10.1192 6.73955 9.67989C7.27549 9.24056 7.94701 9.00033 8.64 9H20.78C21.0763 8.99926 21.3691 9.06437 21.6371 9.19062C21.9052 9.31687 22.1419 9.5011 22.33 9.73C22.5168 9.95919 22.6504 10.2269 22.7213 10.514C22.7922 10.801 22.7986 11.1002 22.74 11.39Z",
    fill: "#C32A7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseManagement);
export default __webpack_public_path__ + "static/media/case_management.485f9693e4c006399c21e61802818e13.svg";
export { ForwardRef as ReactComponent };